module.exports = __webpack_public_path__ + "img/select.d29e4606.svg";